/**
 * Layout 组件 Widget 类（6.2 BaseWidget 体系）
 * Page / Container / Card / Grid / Flex / Stack / Tabs / Sidebar
 */
import type { PropertyPaneConfig } from "@shared/types";

import { getMaterial } from "../materials";
import { BaseWidget } from "./base-widget";
import { buildMaterialPropertyPaneConfig } from "./property-pane";

function paneConfigFor(type: string, extraSections: PropertyPaneConfig[] = []): PropertyPaneConfig[] {
  return buildMaterialPropertyPaneConfig(getMaterial(type)?.propSchema ?? [], extraSections);
}

export class PageWidget extends BaseWidget {
  getWidgetType(): string {
    return "Page";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Page");
  }
}

export class ContainerWidget extends BaseWidget {
  getWidgetType(): string {
    return "Container";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Container");
  }
}

export class CardWidget extends BaseWidget {
  getWidgetType(): string {
    return "Card";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Card");
  }
}

export class GridWidget extends BaseWidget {
  getWidgetType(): string {
    return "Grid";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Grid");
  }
}

export class FlexWidget extends BaseWidget {
  getWidgetType(): string {
    return "Flex";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Flex");
  }
}

export class StackWidget extends BaseWidget {
  getWidgetType(): string {
    return "Stack";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Stack");
  }
}

export class TabsWidget extends BaseWidget {
  getWidgetType(): string {
    return "Tabs";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Tabs");
  }
  getMetaProperties(): Record<string, unknown> {
    return { activeValue: "" };
  }
}

export class SidebarWidget extends BaseWidget {
  getWidgetType(): string {
    return "Sidebar";
  }
  getPropertyPaneConfig(): PropertyPaneConfig[] {
    return paneConfigFor("Sidebar");
  }
  getMetaProperties(): Record<string, unknown> {
    return { isCollapsed: false };
  }
}
